import { render, staticRenderFns } from "./takeoutSideboardOrder.vue?vue&type=template&id=223e2a28&scoped=true&"
import script from "./takeoutSideboardOrder.vue?vue&type=script&lang=js&"
export * from "./takeoutSideboardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e2a28",
  null
  
)

export default component.exports